import { ref }         from "vue";
import { useStore }    from "vuex";
import { get as _get } from "lodash-es";

export default function getCopydeck ()
{
    const store = useStore();

    const copydeck = ref( store.state.copydeck );
    const lang     = "fr";

    const handler =
              {
                  get : ( target, name ) =>
                  {
                      let obj = _get( target, name );

                      if ( obj === undefined )
                      {
                          let type = typeof name;

                          if ( type === "symbol" )
                          {
                              //if we have not found something, we check if we can find a localized version
                              let loc = _get( target, lang );

                              if ( loc )
                              {
                                  return () => loc;
                              }
                          }

                          return name;
                      } else if ( typeof obj === "string" )
                      {
                          return obj
                      }

                      if ( typeof obj !== "object" && typeof obj !== "function" )
                      {
                          return obj;

                      }

                      return new Proxy( obj, handler );
                  },


              };

    return new Proxy( copydeck.value, handler );
}






